import { gql } from '@apollo/client';

export const ADD_UPDATE_SCHEDULE_TYPE_CELL_PARAM_TEMPLATE = gql`
  mutation addOrUpdateScheduleTypeCellParamTemplate($input: ScheduleTypeCellParamTemplateItemInput) {
    addOrUpdateScheduleTypeCellParamTemplate(input: $input) {
      commandId
      correlationId
    }
  }
`;
